import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M10.695 2.396a.6.6 0 0 1 .848 0l1.765 1.765a.6.6 0 0 1 0 .848l-1.765 1.765a.6.6 0 1 1-.848-.848l.811-.812a6.902 6.902 0 1 0 4.555 1.302.6.6 0 1 1 .706-.97 8.102 8.102 0 1 1-5.396-1.525l-.676-.677a.6.6 0 0 1 0-.848Z"
      clip-rule="evenodd"
    />
  </svg>
`;
